<template>
    <div style="padding: 10px">
        <div class="title-line"><i :class="iconclass+' iconstyle'"></i>{{message}}</div>
        <div class="bottom-line"></div>
    </div>
</template>

<style scoped>
    .title-line{
        display: inline-block;
        line-height: 30px;
        vertical-align: top;
        padding-top: 5px;
        font-family: "Microsoft YaHei";
        font-size: 32px;
    }

    .iconstyle {
        color: #199ED8;
        margin-left: 0px;
        margin-right: 13px;
    }

    .bottom-line {
        border: #199ED8 solid 1px;
        margin-bottom:12px;
        margin-top: 9px;

    }

</style>


<script>
  export default {
    name: 'topLine',
    props:['message','iconclass'],
    data(){
      return {

      };
    }
  }
</script>

